import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/pnmb-logo.png";
import lawnetLogo from "../../assets/images/LOGO LAWNET WHITE.png";
import lawImage from "../../assets/images/law-image.jpg";
import { PiEyeLight, PiEyeClosedLight } from "react-icons/pi";
import api from "../../services/baseUrl";
import Cookies from "js-cookie";
import ForceLogoutModal from "../../components/ForcedLogoutModal";

const LoginPage = () => {
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [forgotPasswordUsername, setForgotPasswordUsername] = useState("");
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [userObject, setUserObject] = useState();
  const [errors, setErrors] = useState({
    username: "",
    password: "",
  });
  const [renewButton, setShowRenewButton] = useState(false);

  sessionStorage.clear();
      Cookies.remove("token", { secure: true, sameSite: "Strict" });

  useEffect(() => {
    // const cookie = Cookies.get("user");
    const cookie = sessionStorage.getItem("user");
    if (cookie) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const validateForm = () => {
    let formErrors = {};
    if (!username) formErrors.username = "Username is required";
    if (!password) formErrors.password = "Password is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const login = async () => {
    try {
      const response = await api.post("/api/login", {
        username: username,
        password: password,
      });
      console.log("Login Repsonse = " + response);

      const { data, token } = response.data;
      console.log("Token = " + token);
      const userObject = data;
      console.log(userObject);
      console.log(JSON.stringify(userObject));
      console.log("rememberMe = " + rememberMe);

      if (rememberMe) {
        console.log("Beofre set cookie. remmber");
        Cookies.set("token", token, {
          expires: 1, // 1 day
          //secure: true, // ensures cookie is sent over HTTPS
          //sameSite: "Strict", // mitigates CSRF
        });
        console.log("In between");
        Cookies.set("user", JSON.stringify(userObject), {
          expires: 1,
          //secure: true,
          //sameSite: "Strict",
        });
        console.log("After set cookie.");
      } else {
        console.log("Beofre set cookie. ");
        Cookies.set("token", token, {
          //secure: true,
          //sameSite: "Strict",
        });
        console.log("In between");
        // Cookies.set("user", JSON.stringify(userObject), {
          //secure: true,
          //sameSite: "Strict",
        // });
        //Cookies.set("user", userObject);
        sessionStorage.setItem("user", JSON.stringify(userObject));
        console.log("After set cookie.");
      }

      console.log("before redirect");
      navigate("/dashboard");
      console.log("after redirect");
    } catch (error) {
      console.error("Login error:", error);

      const resData = error.response?.data;
      const status = error.response?.status;

      const fetchCustomer = async (id) => {
        const response = await api.get("/user/customer", {
          params: { id },
        });
        if (response.status === 200) {
          if (response.data.categoryID === 8) {
            navigate("/payment", { state: resData.data });
          } else {
            navigate("/upload-document");
          }
        }
      };
      const fetchCustomerUser = async (email) => {
        const response = await api.get("/user/customerUser", {
          params: { email },
        });
        if (response.status === 200) {
          fetchCustomer(response.data.customerID);
        }
      };
      if (
        status === 401 &&
        resData?.message ===
          "User needs to upload their LO/PO or payment proof" &&
        resData?.data !== null
      ) {
        fetchCustomerUser(resData.data.email);
        return;
      }

      if (status === 401 && resData?.message === "User account is expired"){
        const fallbackMessage = resData?.message || "Login failed";
        setErrorMessage(fallbackMessage);
        setUserObject(resData?.data);
        setShowRenewButton(true);
      }
        if (status === 409) {
          setShowSessionModal(true);
          return;
        }

      const fallbackMessage = resData?.message || "Login failed";
      setErrorMessage(fallbackMessage);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      login();
    }
  };

  const navigateHome = () => {
    navigate("/");
  };

  const handleOutsideClick = (e) => {
    if (e.target.id === "modalBackground") {
      setIsModalOpen(false);
    }
  };

  const forgotPassword = async () => {
    if (email === "") {
      window.alert("Email is required");
      return;
    }
    if (forgotPasswordUsername === "") {
      window.alert("Username is required");
      return;
    }
    try {
      const response = await api.post("/user/forgotpassword", {
        email,
        username: forgotPasswordUsername,
      });

      if (response.status === 200) {
        window.alert(
          "Email with a temporary password has been sent, please check your email."
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          window.alert("Email not found. Please register a new account.");
        }
        console.error(
          `Error: ${error.response.status} - ${error.response.data}`
        );
      } else {
        console.error("Network error or server unreachable", error);
      }
    }
  };

  const renew = () => {
    const formData = {
      name: userObject.user.fullName,
      packageID: userObject.packageModel.packageCode,
      categoryId: userObject?.customer?.categoryID || 8,
      email: userObject?.user?.email,
      username: userObject?.user?.userName,
      expiryDate: userObject?.customerUserPackageModel?.expiryDate
    };

    navigate("/payment", { state: formData });
  };

  const handleForceLogout = async () => {
    try {
      await api.post("/api/force-logout-oldest", { username });
      setShowSessionModal(false);
      login();
    } catch (err) {
      console.error("Force logout failed", err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-container">
        <img src={logo} alt="" className="login-logo" onClick={navigateHome} />
        <img
          src={lawnetLogo}
          alt=""
          className="login-lawnet-text"
          onClick={navigateHome}
        />
        <img src={lawImage} alt="" className="login-image" />
      </div>
      <div className="login-welcome-container">
        <div className="login-welcome">
          <h1>Welcome back</h1>
          <p className="login-subtitle">Login to your account</p>
          <form className="login-form" onSubmit={handleLogin}>
            <div>
              <div className="form-input-field">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  name="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                {errors.username && (
                  <span className="form-error">{errors.username}</span>
                )}
              </div>

              <div className="form-input-field">
                <label htmlFor="password">Password</label>
                <div className="login-password">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="login-toggle-icon"
                    onClick={togglePasswordVisibility}
                  >
                    {isPasswordVisible ? (
                      <PiEyeLight size={16} />
                    ) : (
                      <PiEyeClosedLight size={16} />
                    )}
                  </span>
                </div>
                {errors.password && (
                  <span className="form-error">{errors.password}</span>
                )}
              </div>
              <div className="login-remember" style={{ marginTop: 5 }}>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label>Remember me</label>
              </div>
              <p style={{ fontSize: 10, marginTop: "10px" }}>
                Forgot your password? Click{" "}
                <span
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => setIsModalOpen(true)}
                >
                  here
                </span>
              </p>
              <div style={{display:"flex"}}>
                {errorMessage && (
                  <p className="login-error-message">{errorMessage}</p>
                )}
                {renewButton && <p className="renew-link" onClick={()=>{
                  renew();
                }}>Renew Here</p>}
              </div>

              <button className="login-button" type="submit">
                Login
              </button>
              <button
                className="login-register-button"
                type="button"
                onClick={() => {
                  navigate("/register");
                }}
              >
                Sign Up
              </button>
            </div>
          </form>
        </div>
        <div style={{ position: "fixed", bottom: 10 }}>
          <p className="login-footer">Powered by PNMB</p>
        </div>
      </div>
      {isModalOpen && (
        <div
          id="modalBackground"
          onClick={handleOutsideClick}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "white",
              padding: 25,
              borderRadius: 10,
              width: "500px",
              position: "relative",
              display: "flex",
              flexDirection: "column",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Reset Password</h3>
            <input
              type="text"
              placeholder="Enter your username"
              value={forgotPasswordUsername}
              onChange={(e) => setForgotPasswordUsername(e.target.value)}
              style={{
                width: "96%",
                padding: "8px",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            />
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "96%",
                padding: "8px",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <button
                onClick={() => {
                  forgotPassword();
                  setIsModalOpen(false);
                }}
                style={{
                  padding: "8px",
                  background: "#0d6bfe",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  width: "20%",
                }}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      )}

      <ForceLogoutModal
        isOpen={showSessionModal}
        onConfirm={handleForceLogout}
        onCancel={() => setShowSessionModal(false)}
      />
    </div>
  );
};

export default LoginPage;
